package pnemonic.balloon_pop.view.theme

import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape

val shapeButton = CircleShape
val shapePanel = RoundedCornerShape(50)
